<template>
  <div>
    <br /><br />
    <h2 style="text-align:center">
      {{ msg }}
      <!-- <a href="/#/active"><i class="el-icon-d-arrow-right"></i></a> -->
    </h2>

    <el-divider id="divider2"></el-divider>
    <h2 style="text-align:center">
      {{ msg1 }}
    </h2>
  </div>
</template>

<script>
export default {
  name: "Divider1",
  data() {
    return {
      msg: "旗下产品",
      msg1: "PRODUCTS"
    };
  }
};
</script>

<style scoped>
#divider2 {
  margin: 0 auto;
  width: 120px;
  border-top: 3px solid #97b9ff;
}

a {
  text-decoration: none;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/divider1.vue